import { Component, ViewEncapsulation, Input, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { ResizeService } from '../../services/resize.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetComponent {

  @Input()
  set widget(name) {
    this.widgetName = name;
    this.widgetClass = `widget--${name}`;
    this.widgetHeaderClass = `widget__header--${name}`;
  }

  @Input()
  set type(value) {
    this.widgetClass = `widget--${value}`;
    this.widgetHeaderClass = `widget__header--${value}`;
  }

  public widgetName = null;
  public widgetClass = 'widget--regular';
  public widgetHeaderClass = 'widget__header--regular';

  constructor(
    public element: ElementRef,
    public store: Store,
    public resizeService: ResizeService
  ) { }

}
